import http from '@/utils/http'

const fetch = () => http()
  .get('/expert')

const save = ({ data }) => http()
  .put('/expert', data)

const isRestricted = expert => expert && expert.role === 'restricted'

const isAdmin = expert => expert && expert.role === 'main'

export default {
  fetch,
  save,
  isAdmin,
  isRestricted
}



// WEBPACK FOOTER //
// ./src/api/currentExpert.js